import { Tasks } from '../components/Tasks';

export function TasksPage() {
  return <Tasks />;
}
